import { Auth0Client } from '@auth0/auth0-spa-js';
import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID,
  AUTH0_TENANT_DOMAIN,
} from '../common/constants/env.constants';

// Used for the Mac login, which navigates the task pane itself to Auth0. That only works for a
// domain in the installed manifest's AppDomains, so it uses the tenant domain every manifest lists.
const auth0 = new Auth0Client({
  domain: AUTH0_TENANT_DOMAIN,
  clientId: AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: globalThis.location.origin + '/auth-callback',
    audience: AUTH0_AUDIENCE,
  },
});
export default auth0;
